'use client'

import { styled } from 'styled-components'

import { Section } from './ui'

/**
 * Strips the padding a `BaseCarousel` provides for itself, for the case where it is rendered
 * inside a `ShopMarketplaceGroup` that already supplies it.
 *
 * The group is `padding: 3rem; gap: 3rem` and `Section` is another `3rem` on top, so without this
 * a carousel placed in a group sits in roughly double the space of its neighbours — which is what
 * the homepage looked like while Recently Viewed was the one row rendered outside the groups.
 */
export const InsideGroupWrapper = styled.div`
  ${Section} {
    padding: 0;
  }
`
